import { render } from "./AdminDiscountView.vue?vue&type=template&id=63d08254&scoped=true"
import script from "./AdminDiscountView.vue?vue&type=script&lang=js"
export * from "./AdminDiscountView.vue?vue&type=script&lang=js"

import "./AdminDiscountView.vue?vue&type=style&index=0&id=63d08254&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d08254"]])

export default __exports__